import { isNil } from "lodash";

import { ViewDto } from "../dto";
import { ViewScopeEnum } from "../enums/";
import { Log } from "./log.helpers";

export const resolveScope = (view: ViewDto): ViewScopeEnum => {
  switch (true) {
    case isNil(view.userId) && isNil(view.companyId):
      return ViewScopeEnum.GLOBAL;
    case isNil(view.userId) && !isNil(view.companyId):
      return ViewScopeEnum.COMPANY;
    case !isNil(view.userId) && !isNil(view.companyId):
      return ViewScopeEnum.USER;
    default:
      Log.error(
        "Cannot resolve view scope, switched to user scope, for view:",
        view,
      );

      return ViewScopeEnum.USER;
  }
};

export const resolveDefaultView = ({
  viewDtos,
  userId,
  companyId,
}: {
  viewDtos: ViewDto[] | undefined;
  userId?: number;
  companyId?: number;
}): ViewDto | undefined => {
  if (!viewDtos) {
    return undefined;
  }

  const firstUserScopeDefaultView =
    userId &&
    viewDtos.find(
      view =>
        view.userId === userId &&
        view.companyId === companyId &&
        view.isDefault,
    );

  if (firstUserScopeDefaultView) {
    return firstUserScopeDefaultView;
  }

  const firstCompanyScopeDefaultView =
    companyId &&
    viewDtos.find(
      view =>
        isNil(view.userId) && view.companyId === companyId && view.isDefault,
    );

  if (firstCompanyScopeDefaultView) {
    return firstCompanyScopeDefaultView;
  }

  const firstGlobalScopeDefaultView = viewDtos.find(
    view => isNil(view.userId) && isNil(view.companyId) && view.isDefault,
  );

  return firstGlobalScopeDefaultView;
};
